import { useEffect } from "react";
import { PhonebookTable } from "../components/phonebook/PhonebookTable";
import { usePhonebook } from "../hooks/usePhonebook";

export const PhonebookContainer = () => {
  const { contacts, organizations, loadContacts } = usePhonebook();

  useEffect(() => {
    loadContacts();
  }, []);

  return (
    <div className="foc-content flex flex-col overflow-hidden">
      <main className="flex min-h-0 flex-1 flex-col overflow-hidden bg-slate-50/40 p-5">
        <div className="min-h-0 flex-1 overflow-hidden">
          <PhonebookTable />
        </div>
      </main>
    </div>
  );
};
